import { WarningAmber as WarningAmberIcon } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Math } from 'classes';
import { StatusLabel } from 'components';
import { useMeta } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { Trader } from 'types';
import { formatUtils, traderUtils } from 'utils';

export const TraderStatus = ({ trader }: { trader: Trader }) => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'pages.traders',
  });
  const { isPayoutVolumeControlEnabled } = useMeta();

  const payoutVolumeAvailable = new Math(
    trader.payoutVolumeAvailableBalance ?? 0,
  ).plus(trader.payoutVolumeMaxDeviation ?? 0).value;

  return (
    <div className="tw-flex tw-items-center">
      <StatusLabel
        label={traderUtils.getWorkStatusLabel(trader.workStatus)}
        status={trader.workStatus}
      />
      {trader.unableTakeOrders && (
        <Tooltip
          title={
            trader.unableTakeOrdersUntilAt
              ? t('unable_take_orders_trader_time', {
                  date: formatUtils.formatDate(trader.unableTakeOrdersUntilAt),
                })
              : t('unable_take_orders_trader')
          }
        >
          <WarningAmberIcon color="error" />
        </Tooltip>
      )}
      {isPayoutVolumeControlEnabled &&
        trader.payoutVolumeControlEnabled &&
        payoutVolumeAvailable <= 0 && (
          <Tooltip
            title={t('payout_volume_warning', {
              amount: formatUtils.formatNumber(payoutVolumeAvailable),
            })}
          >
            <WarningAmberIcon color="warning" />
          </Tooltip>
        )}
    </div>
  );
};
